/* ============================================================================
   Decryption/scramble reveal on section kickers, site-wide.
   Port of reactbits.dev/text-animations/decrypted-text to vanilla JS (no React).

   Purely a text-content swap — font, size, tracking, and color come from .kicker
   and are never touched here. The kicker face is monospaced, so scrambling causes
   no layout shift.

   Tuning lives in CONFIG below: minDuration sets the floor for short strings,
   speed sets the tick rate (and so how long long strings run).
   Self-contained: this file plus one <script> tag in layout/theme.liquid.
   ============================================================================ */
(function () {
  var SELECTOR = '.kicker';

  var CONFIG = {
    speed: 70, // ms per tick
    sequential: true, // reveal one char at a time (vs. maxIterations scramble)
    revealDirection: 'start', // 'start' | 'end' | 'center'
    maxIterations: 10, // only used when sequential is false
    /* Sequential reveal takes length × speed, so a 12-char kicker was over in half
       the time of a 31-char one. Hold short strings in pure scramble first so every
       kicker runs for at least this long and the effect actually reads. */
    minDuration: 1500, // ms
    /* on-brand pool: the kickers are ALL-CAPS Share Tech Mono, so keeping the pool
       uppercase/symbolic matches the HUD look. Mono = every glyph is the same
       width, so scrambling never shifts layout. */
    characters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/\\<>[]{}*#%&_+=!?'
  };

  /* Respect the OS setting — this is decoration, not information. */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function randChar() {
    return CONFIG.characters[Math.floor(Math.random() * CONFIG.characters.length)];
  }

  /* Replace every not-yet-revealed, non-space character with a random one. */
  function shuffle(original, revealed) {
    var out = '';
    for (var i = 0; i < original.length; i++) {
      if (original[i] === ' ') out += ' ';
      else if (revealed.has(i)) out += original[i];
      else out += randChar();
    }
    return out;
  }

  /* Which index to reveal on tick n, per direction. */
  function nextIndex(revealedCount, len) {
    switch (CONFIG.revealDirection) {
      case 'end':
        return len - 1 - revealedCount;
      case 'center': {
        var mid = Math.floor(len / 2);
        var offset = Math.floor(revealedCount / 2);
        var i = revealedCount % 2 === 0 ? mid + offset : mid - offset - 1;
        if (i >= 0 && i < len) return i;
        return -1; // caller falls back to the first unrevealed slot
      }
      default:
        return revealedCount;
    }
  }

  function run(el) {
    var original = el.textContent;
    if (!original.trim()) return;

    var revealed = new Set();
    var iterations = 0;
    el.setAttribute('aria-label', original); // keep the real string for assistive tech

    /* ticks of pure scramble before the reveal starts, so short strings last as long
       as long ones. Long strings already exceed minDuration and get none. */
    var leadIn = Math.max(0, Math.ceil((CONFIG.minDuration - original.length * CONFIG.speed) / CONFIG.speed));

    var timer = setInterval(function () {
      if (leadIn > 0) {
        leadIn--;
        el.textContent = shuffle(original, revealed);
        return;
      }
      if (CONFIG.sequential) {
        if (revealed.size >= original.length) {
          clearInterval(timer);
          el.textContent = original;
          return;
        }
        var i = nextIndex(revealed.size, original.length);
        if (i < 0 || revealed.has(i)) {
          // center mode can collide — take the first free slot instead
          for (var j = 0; j < original.length; j++) {
            if (!revealed.has(j)) { i = j; break; }
          }
        }
        revealed.add(i);
        el.textContent = shuffle(original, revealed);
      } else {
        iterations++;
        if (iterations > CONFIG.maxIterations) {
          clearInterval(timer);
          el.textContent = original;
          return;
        }
        el.textContent = shuffle(original, revealed);
      }
    }, CONFIG.speed);
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target); // once per element, like animateOn="view"
        run(en.target);
      });
    },
    { threshold: 0.6 }
  );

  function observeAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.decrypted) return; // never re-arm one that already ran
      el.dataset.decrypted = '1';
      io.observe(el);
    });
  }

  observeAll();

  /* Theme editor re-renders a section's markup on every settings change, which
     replaces its kickers. Pick up the new nodes so the effect survives editing. */
  document.addEventListener('shopify:section:load', function (e) { observeAll(e.target); });
})();
